<template>
    <!-- 头部 -->
    <div>
        <div class="top_header">
            <!-- 中 -->
            <div class="title">
                <img class="font" src="../assets/images/logo.png" alt="">
                <div>校园餐常态化监管云平台</div>
            </div>
        </div>
        <div class="bottom_header" v-if="!hideSchoolNameAndTime">
            <!-- 左 -->
            <div class="left flex">
                <div>
                     {{ handleDeptName(deptName) }}
                </div>
            </div>
            <!-- 右 -->
            <div class="right">
                <div class="right-addres">
                    <div class="data-time">
                        <div class="time">{{time}}</div>
                    </div>
                    <div>
                        {{weekValue}}
                    </div>
                    <!-- 缩放全屏 -->
                    <!-- <div
                    class="scaling"
                    @click="onClickScale"
                >
                    <img
                        class="scal_icon"
                        :src="!zoomState ? scaleAll : scaleSmall"
                        alt
                    />
                </div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        getQueryObjByUrl,
        handleTime,
        formatTime,
        getWeek
    } from "@/assets/js/common";
    import { HIDE_BG_TAB } from '@/assets/js/constants';
    import {
        fullscreenToggel,
        listenfullscreen,
        fullscreenEnable
    } from "@/assets/js/fullscreen"; //全屏方法
    import { handleDeptName } from "@/assets/js/mock";
    export default {
        name: 'headerPage',
        computed: {},
        data() {
            return {
                time: '', // 时间
                weekValue: '',
                hideSchoolNameAndTime: false,
                // 星期
                weekArr: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"],
                deptName: '',
                deptId: '',
                zoomState: JSON.parse(localStorage.getItem('zoomState')),
                scaleAll: require('@/assets/images/icon_quanping.png'),
                scaleSmall: require('@/assets/images/icon_fanhui.png')
            }
        },
        watch: {
            $route(to) {
                console.log(to, 'url值改变')
                if (Object.keys(to.query).length > 0) {
                    let did = to.query.id;
                    this.deptId = !did ? localStorage.getItem('deptId') : did;
                    this.deptName = ''
                } else {
                    this.deptId = ''
                }
                this.getCanteenDisplay()
                this.handleHideSomeInfos()
            }
        },
        methods: {
            handleHideSomeInfos() {
                try {
                    this.hideSchoolNameAndTime = false
    
                    const itemObj = getQueryObjByUrl()
                    const indexArr = itemObj.item.split(',')
                    const hideMenu = HIDE_BG_TAB // 黑名单, 对应类型隐藏顶部的学校和时间
                    hideMenu.forEach(item => {
                        if (indexArr.includes(item)) {
                            this.hideSchoolNameAndTime = true
                        }
                    })
    
                } catch (error) {
                    console.error('(headerPageVertical.vue)自定义捕捉错误error:', error)
                }
            },

            // 全屏
            onClickScale() {
                listenfullscreen(true); // esc监听全屏
                fullscreenToggel(); // 全屏
                this.zoomState = JSON.parse(localStorage.getItem('zoomState'))
            },
            // 获取当天星期几
            week() {
                let times = formatTime(new Date(), 'yyyy-MM-dd')
                let week = getWeek(times)
                return week
            },
            /**
             * @function getCanteenDisplay 食堂名称
             * @param deptId 食堂id
             */
            getCanteenDisplay() {
                this.$get(this.$api.getCanteenDisplay, {
                    deptId: this.deptId
                }).then(res => {
                    console.log('食堂名称-res', res)
                    const {
                        code,
                        success,
                        data
                    } = res
                    if (code == 200 && success) {
                        this.deptName = data.deptName
                    }
                }).catch(err => {
                    // this.$message.error(err.message);
                    console.log('食堂名称-err', err)
                })
            },
            handleDeptName,
        },
        created() {
            this.deptId = localStorage.getItem('deptId')
            //  this.deptId ='1466336161432678401'
            //获取星期
            this.weekValue = this.week()
            this.getCanteenDisplay()
            this.handleHideSomeInfos()
        },
        mounted() {
            setInterval(() => {
                this.time = handleTime()
                this.weekValue = this.week()
            }, 1000);
            let _that = this
            window.onresize = function temp() { // 监听窗口变动
                if (!fullscreenEnable()) {
                    localStorage.setItem('zoomState', false)
                    _that.zoomState = JSON.parse(localStorage.getItem('zoomState'))
                }
            };
        },
        beforeCreate() {}, //生命周期 - 创建之前
        beforeMount() {}, //生命周期 - 挂载之前
        beforeUpdate() {}, //生命周期 - 更新之前
        updated() {}, //生命周期 - 更新之后
        beforeDestroy() {}, //生命周期 - 销毁之前
        destroyed() {}, //生命周期 - 销毁完成
        activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>

<style lang="scss" scoped>
    .top_header {
        @include flex(center);
        height: vh(80);
        background: url(../assets/images/page_bg_deep_vertical_top.png) no-repeat;
        background-size: 100% 100% !important;

        .title {
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: vh(30);
            color: #00fcff;
            text-align: center;
            font-weight: bold;
            letter-spacing: 3px;

            img {
                width: vh(35); 
                margin: 0 vh(15) 0 0;
                vertical-align: middle;
                object-fit: contain;
            }
        }
    }

    .bottom_header {
        @include flex(space-between);
        font-size: vh(15);
        padding: 0 vh(30);
        margin-top: vh(15); 

        .left {
            color: #3ceaff;
            white-space: nowrap;

            img {
                width: vh(46);
                height: vh(69);
                margin-right: vh(20);
            }
        }

        .right {
            white-space: nowrap;

            .right-addres {
                @include flex(flex-end);

                .data-time {
                    text-align: center;
                    margin-right: vh(20);
                    @include flex(flex-start);

                    .time {
                        color: $time_color;
                    }
                }

                color: $time_color;

                .scaling>img {
                    width: vh(30);
                    margin-left: vh(10);
                }
            }
        }

        .left,
        .right {
            width: 25%;
            align-self: flex-end;
        }
    }
</style>